import { app } from '../app.module'
/**
 * カテゴリデータに関するService
 * @param  {Function} Restangular Restangular
 * @param  {Function} $q Promise用
 * @return {Object} オブジェクト
 */
function CategoryData(Restangular, $q) {
  /**
   * getCategoriesList カテゴリ(大カテゴリ・小カテゴリ)一覧を取得
   * @param {object} getOptions 取得オプション(取得対象月、取得対象業種)
   * @return {Object} カテゴリ一覧
   */
  function getCategoriesList() {
    const deferred = $q.defer()

    // データを取得
    Restangular.all('/category/getCategoriesList')
      .getList()
      .then((result) => {
        deferred.resolve(result[0].data)
      })
    return deferred.promise
  }

  /**
   * サブカテゴリを削除する
   * @param categoryInfo カテゴリ情報
   * @return サーバーからの結果
   */
  function deleteSubCategory(categoryInfo: { categoryName: string; subCategoryName: string }) {
    const deferred = $q.defer()

    const postUrl = '/category/deleteSubCategory'

    Restangular.all(postUrl)
      .post(categoryInfo)
      .then((result) => {
        deferred.resolve(result[0].data)
      })

    return deferred.promise
  }

  return {
    getCategoriesList: getCategoriesList,
    deleteSubCategory: deleteSubCategory,
  }
}

/**
 * CategoryService カテゴリ関連のサービスを1つのサービスにオブジェクトとして格納
 * @param {Function} CategoryData カテゴリデータに関するService
 * @return {Object} サービスのオブジェクト
 */
function CategoryService(CategoryData) {
  return {
    CategoryData: CategoryData,
  }
}

// サービスを定義
app.factory('CategoryService', CategoryService).factory('CategoryData', CategoryData)
